import React from 'react'
import { useAppSelector } from 'store/hooks'
import { Navigate, useLocation } from 'react-router-dom'

import usePathListener from 'hooks/usePathListener'
import { selectAuthorized, selectUserRole } from 'lib/helpers/selectors'

import { ROUTES } from '../constants'

import { Role } from 'models/user'

interface Props {
  inverse?: boolean
  roles: Role[]
}

export const AuthorizationHub: React.FC<Props> = ({
  inverse = false,
  roles,
  children,
  ...props
}) => {
  const { pathname } = useLocation()

  const logged = useAppSelector(selectAuthorized)
  const currentRole = useAppSelector(selectUserRole)
  const authorized = logged && roles.some(r => currentRole?.id === r.id)

  usePathListener(pathname, !authorized)

  const showComponent = (authorized && !inverse) || (!authorized && inverse)
  const redirect = inverse ? ROUTES.HOME : ROUTES.LOGIN

  return (
    <>
      {!showComponent && <Navigate to={redirect} replace />}
      {showComponent && children}
    </>
  )
}

export default AuthorizationHub
